import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index11() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-slider-container mb-4">
    <div className="intro-slider owl-carousel owl-simple owl-nav-inside" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;responsive&quot;: {
                      &quot;992&quot;: {
                          &quot;nav&quot;: true,
                          &quot;dots&quot;: false
                      }
                  }
              }">
      <div className="intro-slide" style={{backgroundImage: 'url(asset/images/demos/demo-11/slider/slide-1.jpg)'}}>
        <div className="container intro-content">
          <h3 className="intro-subtitle text-primary">SEASONAL PICKS</h3>{/* End .h3 intro-subtitle */}
          <h1 className="intro-title">Get All <br />The Good Stuff</h1>{/* End .intro-title */}
          <a href="category.html" className="btn btn-outline-primary-2">
            <span>DISCOVER MORE</span>
            <i className="icon-long-arrow-right" />
          </a>
        </div>{/* End .intro-content */}
      </div>{/* End .intro-slide */}
      <div className="intro-slide" style={{backgroundImage: 'url(asset/images/demos/demo-11/slider/slide-2.jpg)'}}>
        <div className="container intro-content">
          <h3 className="intro-subtitle text-primary">all at 50% off</h3>{/* End .h3 intro-subtitle */}
          <h1 className="intro-title text-white">The Most Beautiful <br />Novelties In Our Shop</h1>{/* End .intro-title */}
          <a href="category.html" className="btn btn-outline-primary-2 min-width-sm">
            <span>SHOP NOW</span>
            <i className="icon-long-arrow-right" />
          </a>
        </div>{/* End .intro-content */}
      </div>{/* End .intro-slide */}
    </div>{/* End .intro-slider owl-carousel owl-simple */}
    <span className="slider-loader" />{/* End .slider-loader */}
  </div>{/* End .intro-slider-container */}
  <div className="container">
    <div className="toolbox toolbox-filter">
      <div className="toolbox-left">
        <a href="#" className="filter-toggler">Filters</a>
      </div>{/* End .toolbox-left */}
      <div className="toolbox-right">
        <ul className="nav-filter product-filter">
          <li className="active"><a href="#" data-filter="*">All</a></li>
          <li><a href="#" data-filter=".furniture">Furniture</a></li>
          <li><a href="#" data-filter=".lighting">Lighting</a></li>
          <li><a href="#" data-filter=".accessories">Accessories</a></li>
          <li><a href="#" data-filter=".sale">Sale</a></li>
        </ul>
      </div>{/* End .toolbox-right */}
    </div>{/* End .filter-toolbox */}
    <div className="widget-filter-area" id="product-filter-area">
      <a href="#" className="widget-filter-clear">Clean All</a>
      <div className="filter-area-wrapper">
        <div className="row">
          <div className="col-sm-6 col-lg-3">
            <div className="widget">
              <h3 className="widget-title">
                Category:
              </h3>{/* End .widget-title */}
              <div className="filter-items filter-items-count">
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="cat-1" />
                    <label className="custom-control-label" htmlFor="cat-1">All</label>
                  </div>{/* End .custom-checkbox */}
                  <span className="item-count">24</span>
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="cat-2" />
                    <label className="custom-control-label" htmlFor="cat-2">Furniture</label>
                  </div>{/* End .custom-checkbox */}
                  <span className="item-count">3</span>
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="cat-3" />
                    <label className="custom-control-label" htmlFor="cat-3">Lighting</label>
                  </div>{/* End .custom-checkbox */}
                  <span className="item-count">2</span>
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="cat-4" />
                    <label className="custom-control-label" htmlFor="cat-4">Accessories</label>
                  </div>{/* End .custom-checkbox */}
                  <span className="item-count">4</span>
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="cat-5" />
                    <label className="custom-control-label" htmlFor="cat-5">Sale</label>
                  </div>{/* End .custom-checkbox */}
                  <span className="item-count">2</span>
                </div>{/* End .filter-item */}
              </div>{/* End .filter-items */}
            </div>{/* End .widget */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="widget">
              <h3 className="widget-title">
                Sort by:
              </h3>{/* End .widget-title */}
              <div className="filter-items">
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="radio" className="custom-control-input" defaultChecked id="sort-1" name="sortby" />
                    <label className="custom-control-label" htmlFor="sort-1">Default</label>
                  </div>{/* End .custom-checkbox */}
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="radio" className="custom-control-input" id="sort-2" name="sortby" />
                    <label className="custom-control-label" htmlFor="sort-2">Popularity</label>
                  </div>{/* End .custom-checkbox */}
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="radio" className="custom-control-input" id="sort-3" name="sortby" />
                    <label className="custom-control-label" htmlFor="sort-3">Average Rating</label>
                  </div>{/* End .custom-checkbox */}
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="radio" className="custom-control-input" id="sort-4" name="sortby" />
                    <label className="custom-control-label" htmlFor="sort-4">Newness</label>
                  </div>{/* End .custom-checkbox */}
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="radio" className="custom-control-input" id="sort-5" name="sortby" />
                    <label className="custom-control-label" htmlFor="sort-5">Price: Low to High</label>
                  </div>{/* End .custom-checkbox */}
                </div>{/* End .filter-item */}
                <div className="filter-item">
                  <div className="custom-control custom-checkbox">
                    <input type="radio" className="custom-control-input" id="sort-6" name="sortby" />
                    <label className="custom-control-label" htmlFor="sort-6">Price: High to Low</label>
                  </div>{/* End .custom-checkbox */}
                </div>{/* End .filter-item */}
              </div>{/* End .filter-items */}
            </div>{/* End .widget */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="widget">
              <h3 className="widget-title">
                Colour:
              </h3>{/* End .widget-title */}
              <div className="filter-colors filter-colors-vertical">
                <a href="#" style={{background: '#b87145'}}><span>Brown</span></a>
                <a href="#" style={{background: '#f0c04a'}}><span>Yellow</span></a>
                <a href="#" style={{background: '#333333'}}><span>Black</span></a>
                <a href="#" className="selected" style={{background: '#cc3333'}}><span>Red</span></a>
                <a href="#" style={{background: '#ebebeb'}}><span>White</span></a>
              </div>{/* End .filter-colors */}
            </div>{/* End .widget */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="widget">
              <h3 className="widget-title">
                Price:
              </h3>{/* End .widget-title */}
              <div className="filter-price">
                <div className="filter-price-text">
                  Price Range:
                  <span id="filter-price-range" />
                </div>{/* End .filter-price-text */}
                <div id="price-slider" />{/* End #price-slider */}
              </div>{/* End .filter-price */}
            </div>{/* End .widget */}
          </div>{/* End .col-sm-6 col-lg-3 */}
        </div>{/* End .row */}
      </div>{/* End .filter-area-wrapper */}
    </div>{/* End #product-filter-area.widget-filter-area */}
    <div className="products-container" data-layout="fitRows">
      <div className="product-item furniture col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-1.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Flow Slim Armchair</a></h3>{/* End .product-title */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item lighting col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <span className="product-label">Out of stock</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-2.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Swirl Suspension lamp</a></h3>{/* End .product-title */}
            <div className="product-price">
              <div className="out-price">$446.00</div>{/* End .out-price */}
            </div>{/* End .product-price */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item furniture col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-3.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Block Side Table/Trolley</a></h3>{/* End .product-title */}
            <div className="product-price">
              $229.00
            </div>{/* End .product-price */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#e2e2e2'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item accessories lighting sale col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <span className="product-label">Sale</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-4.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Madra Log Holder</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">$103.00</span>
              <span className="old-price">Was $130.00</span>
            </div>{/* End .product-price */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#a48264'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item furniture sale col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <span className="product-label">Sale</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-5.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Foldable Tray Table</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">$320.00</span>
              <span className="old-price">Was $480.00</span>
            </div>{/* End .product-price */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#cba374'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item furniture accessories col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-6.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Original Stonewashed Beanbag</a></h3>{/* End .product-title */}
            <div className="product-price">
              $209.00
            </div>{/* End .product-price */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item accessories lighting col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-7.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Wingback Chair</a></h3>{/* End .product-title */}
            <div className="product-price">
              $2450.00
            </div>{/* End .product-price */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#cc9999'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#999999'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item furniture sale col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-8.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Cushion Set 3 Pieces</a></h3>{/* End .product-title */}
            <div className="product-price">
              $99.00
            </div>{/* End .product-price */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item furniture accessories col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-9.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Garden Armchair</a></h3>{/* End .product-title */}
            <div className="product-price">
              $94.00
            </div>{/* End .product-price */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item accessories col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-10.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Roots Sofa Bed</a></h3>{/* End .product-title */}
            <div className="product-price">
              $337.00
            </div>{/* End .product-price */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item lighting sale col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-11.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Butler Stool Ladder</a></h3>{/* End .product-title */}
            <div className="product-price">
              $251.00
            </div>{/* End .product-price */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
      <div className="product-item lighting sale col-6 col-md-4 col-lg-3">
        <div className="product product-4">
          <figure className="product-media">
            <span className="product-label">Sale</span>
            <a href="product.html">
              <img src="asset/images/demos/demo-11/products/product-12.jpg" alt="Product image" className="product-image" />
            </a>
            <div className="product-action-vertical">
              <a href="#" className="btn-product-icon btn-wishlist btn-expandable"><span>add to wishlist</span></a>
            </div>{/* End .product-action */}
            <div className="product-action">
              <a href="popup/quickView.html" className="btn-product btn-quickview" title="Quick view"><span>quick view</span></a>
            </div>{/* End .product-action */}
          </figure>{/* End .product-media */}
          <div className="product-body">
            <h3 className="product-title"><a href="product.html">Carronade Large Suspension Lamp</a></h3>{/* End .product-title */}
            <div className="product-price">
              <span className="new-price">$892.00</span>
              <span className="old-price">Was $939.00</span>
            </div>{/* End .product-price */}
            <div className="product-nav product-nav-dots">
              <a href="#" className="active" style={{background: '#dddad5'}}><span className="sr-only">Color name</span></a>
              <a href="#" style={{background: '#825a45'}}><span className="sr-only">Color name</span></a>
            </div>{/* End .product-nav */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .product-action */}
          </div>{/* End .product-body */}
        </div>{/* End .product */}
      </div>{/* End .product-item */}
    </div>{/* End .products-container */}
  </div>{/* End .container */}
  <div className="more-container text-center mt-0 mb-7">
    <a href="category.html" className="btn btn-outline-dark-3 btn-more"><span>more products</span><i className="la la-refresh" /></a>
  </div>{/* End .more-container */}
</main>

        <UserFooter/>

    </div>
  )
}

export default Index11